import { IInfoCategoryMasterData } from '@Domains/MasterData';
import {
  IIncomeItemFormValues,
  IIncomeCategoryFormValues,
} from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';
import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';

export type ExportIncomeModalFormValue = IIncomeCategoryFormValues & {
  country: IInfoCategoryMasterData;
};

export const mapCountryToFormValues = (
  data?: IIncomeCategoryFormValues,
  countries?: IInfoCategoryMasterData[]
) => {
  const selectedCountry = findCountryByNameTh(data?.nameTh, countries);

  return {
    country: selectedCountry,
  };
};

const findCountryByNameTh = (
  nameTh?: string,
  countries?: IInfoCategoryMasterData[]
) => {
  return countries?.find((country) => country.nameTh === nameTh);
};

const getSelectedCountries = (data: Record<string, IIncomeItemFormValues>) => {
  return Object.entries(data)
    .map(([, value]) => value.incomeCategory?.nameTh)
    .filter((id) => id !== undefined);
};

export const getOptions = (
  data: Record<string, IIncomeItemFormValues>,
  options: IInfoCategoryMasterData[],
  currentOption: IInfoCategoryMasterData,
  mode: 'create' | 'edit'
) => {
  const prevSelectedCounties = getSelectedCountries(data);

  return options.filter((option) => {
    if (mode === 'edit' && option.nameTh === currentOption.nameTh) {
      return true;
    }
    return !prevSelectedCounties.includes(option.nameTh);
  });
};

export const createNewExtendedExportIncome = (
  formValues: ExportIncomeModalFormValue,
  sequence: number
) => {
  return {
    incomeCategory: {
      nameTh: formValues.country.nameTh,
      nameEn: formValues.country.nameEn,
      subGroup: INCOME_SUBGROUP_CATEGORY.EXPORT_INCOME,
      sequence: sequence,
    },
  };
};

export const updateExportIncomeCategory = (
  formValues: ExportIncomeModalFormValue,
  prevIncomeCategory?: IIncomeCategoryFormValues
) => {
  return {
    ...prevIncomeCategory,
    nameTh: formValues.country.nameTh,
    nameEn: formValues.country.nameEn,
  };
};
